import { useQuery } from '@tanstack/react-query';
import { korzetMondat } from '../elemzes/korzet.ts';
import { supabase } from '../lib/supabase.ts';
import { Betolto, HibaUzenet } from '../ui/elemek.tsx';

/** Az iroda szolgáltatási körzete, csak olvasásra (a szerkesztés a super adminé). Térkép itt nincs. */
export default function KorzetOlvaso({ officeId }: { officeId: string }) {
  const lekeres = useQuery({
    queryKey: ['korzet-olvaso', officeId],
    gcTime: 0,
    queryFn: async () => {
      const { data: iroda, error } = await supabase.from('offices').select('korzet_lat, korzet_lon, korzet_sugar_km').eq('id', officeId).single();
      if (error) throw error;
      if (iroda.korzet_lat === null || iroda.korzet_lon === null || iroda.korzet_sugar_km === null) {
        return { sugarKm: null, kozeliNev: null, be: [] as string[], ki: [] as string[] };
      }
      const { data: kiv, error: kivHiba } = await supabase
        .from('korzet_kivetelek').select('mod, teruletek(nev)').eq('office_id', officeId);
      if (kivHiba) throw kivHiba;
      // A tű legközelebbi területe (1 km-es keresés, távolság szerint rendezve); ha nincs találat, csak a sugár látszik.
      const { data: kozel, error: kozelHiba } = await supabase.rpc('korzet_teruletek', { p_lat: iroda.korzet_lat, p_lon: iroda.korzet_lon, p_km: 1 });
      if (kozelHiba) throw kozelHiba;
      const nevek = (mod: string) => kiv.filter((k) => k.mod === mod && k.teruletek).map((k) => k.teruletek!.nev).sort((a, b) => a.localeCompare(b, 'hu'));
      return { sugarKm: iroda.korzet_sugar_km, kozeliNev: kozel[0]?.nev ?? null, be: nevek('be'), ki: nevek('ki') };
    },
  });

  return (
    <section aria-labelledby="korzet-olvaso-cim" className="grid gap-2 rounded-2xl border border-vonal px-5 py-5">
      <h2 id="korzet-olvaso-cim" className="text-lg font-medium tracking-[-0.015em]">Körzet</h2>
      <HibaUzenet hiba={lekeres.error} />
      {lekeres.isPending && <Betolto />}
      {lekeres.data && (
        <>
          <p>{korzetMondat(lekeres.data.sugarKm, lekeres.data.kozeliNev)}</p>
          {lekeres.data.be.length > 0 && <p className="text-sm">Kivételként benne: {lekeres.data.be.join(', ')}</p>}
          {lekeres.data.ki.length > 0 && <p className="text-sm">Kivételként kimarad: {lekeres.data.ki.join(', ')}</p>}
        </>
      )}
      <p className="text-sm text-szoveg-halk">A körzetet a SocialPro állítja be, a hirdetési kampány sugarával egyezően. Ha módosítana rajta, jelezze nekünk.</p>
    </section>
  );
}
